import { Card, CardContent } from "@mui/material";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "../powerbi.css";

export const PipelineAnalysisList = () => {
  return (
    <Card sx={{ margin: 2, height: "100%" }}>
      <CardContent
        sx={{
          height: "100%",
          padding: 0,
          "&:last-child": { paddingBottom: 0 },
        }}
      >
        <div style={{ height: "100%", width: "100%" }}>
          <PowerBIEmbed
            embedConfig={{
              type: "report",
              embedUrl:
                "https://app.powerbi.com/view?r=eyJrIjoiYWY5Mzg1ZDUtYjU4Yy00Y2VhLThhZjQtYzQ1ZTZlNTBmM2ZlIiwidCI6IjFkYjBkZmU3LWNlNTAtNDZjZC05YmMwLWIzNjY3YzdmMjExZiJ9&chromeless=1&navContentPaneEnabled=false",
              accessToken: "",
              tokenType: models.TokenType.Embed,
              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                  pageNavigation: {
                    visible: false,
                  },
                },
                bars: {
                  actionBar: {
                    visible: false,
                  },
                },
                background: models.BackgroundType.Transparent,
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function () {
                    console.log("Pipeline Analysis report loaded");
                  },
                ],
                [
                  "rendered",
                  function () {
                    console.log("Pipeline Analysis report rendered");
                  },
                ],
                [
                  "error",
                  function (event) {
                    console.log("Pipeline Analysis error:", event?.detail);
                  },
                ],
              ])
            }
            cssClassName="powerbi-report-container"
          />
        </div>
      </CardContent>
    </Card>
  );
};
